import { get } from 'lodash'
import { required, logMinDuration } from 'utils/validation'

const validate = values => {
  return {
    description: required(get(values, 'description')),
    date: required(get(values, 'date')),
    duration: required(get(values, 'duration')) || logMinDuration(30)(get(values, 'duration')),
  }
}

export default validate
